import { Box, Typography } from "@mui/material";
import React from "react";
import { modalStyles } from "./commonStyles";

interface IEmailBodyViewProps {
  body?: string | null;
}

export default function EmailBodyView({ body }: IEmailBodyViewProps) {
  if (!body) return (
    <Box sx={{ ...modalStyles.previewBox }}>
      <Typography textAlign='center'>No Content To Show</Typography>
    </Box >
  );

  return (
    <Box dangerouslySetInnerHTML={{ __html: body }} sx={modalStyles.previewBox} />
  );
}
